import {
    COMPANY_NAME_URL,
    COMPANY_NAME_API_KEY,
    URL_BACK,
} from '../constants/api-constants';
import { axiosInstance } from './axios-instance';

const getCompanyNameService = async (companyId, token) => {
    const config = {
        headers: {
            Authorization: token,
            'x-api-key': COMPANY_NAME_API_KEY,
        },
    };
    return await axiosInstance.get(
        COMPANY_NAME_URL + `?nitCompany=${companyId}`,
        config
    );
};

export const getCompanyName = async (companyId, token) => {
    return await getCompanyNameService(companyId, token);
};

export const getCompanyForRetiredWorkers = async (docType, docNumber, jwt) => {
    return axiosInstance.get(
        `${URL_BACK}/afiliaciones/api/v1/getEmpAfiliacionRetirado?tipoDocumento=${docType}&numeroDocumento=${docNumber}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};
